module.exports = __webpack_public_path__ + "img/guide_img01.37ef0041.jpg";